// Auth related constants
export const AUTH_CONSTANTS = {
  COMPANY_NAME: "Twin Harbour Interactive",
  COPYRIGHT_YEAR: String(new Date().getFullYear()),
  RESTRICTED_ACCESS_MESSAGE:
    "Please sign in using your Stillfront Gmail account only",
  WELCOME_MESSAGE:
    "Setting Sail for Legacy - One platform to control, clean and connect your data automatically",
  SECURITY_MESSAGE:
    "Protected by Google OAuth 2.0 with enterprise-grade security",
} as const;
